/**
 *
 * This file was automatically generated using build-icons npm script and should not be edited
 *
 **/
import { createIcon } from "@cmp-src/icons/create-icon";
export const Calendar1Icon = createIcon({
  displayName: "Calendar1Icon",
  viewBox: "0 0 16 16",
  path: (
    <g fill="none" stroke="currentColor" strokeWidth={1.5}>
      <path
        d="M13 13.25H3C2.30964 13.25 1.75 12.6904 1.75 12V4C1.75 3.30964 2.30964 2.75 3 2.75H13C13.6904 2.75 14.25 3.30964 14.25 4V12C14.25 12.6904 13.6904 13.25 13 13.25Z"
        stroke="currentColor"
        strokeWidth={1.5}
      />
      <rect x={4} y={5} width={1.5} height={1.5} fill="currentColor" />
      <rect x={4} y={1} width={1.5} height={2.5} fill="currentColor" />
      <rect x={10.5} y={1} width={1.5} height={2.5} fill="currentColor" />
    </g>
  )
});
